import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import PageHeader from "../shared/pageHeader/PageHeader";
import Footer from "../shared/Footer";
import Header from "../shared/header/Header";
import NavigationMenu from "../shared/navigationMenu/NavigationMenu";
import { fetchData } from "../../utils/options";

const UserProfile = () => {
  const userId = localStorage.getItem("id");
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        const response = await fetchData(`user/details/${userId}`, {}, "POST");
        if (response.user) {
          setUserData(response.user);
        }
      } catch (error) {
        console.error("Failed to fetch user data:", error);
      }
    };

    if (userId) fetchUserDetails();
  }, [userId]);

  return (
    <>
      <Header />
      <NavigationMenu />
      <main className="nxl-container">
        <div className="nxl-content">
          <PageHeader title="User Profile" />
          <div className="main-content">
            <div className="row">
              <div className="col-lg-12">
                <div className="card p-4">
                  <h5 className="mb-4">User Details</h5>
                  <div className="row">
                    <div className="col-md-4 py-2">
                      <p>
                        <strong>Employee ID:</strong>{" "}
                        {userData?.employ_Id || "-"}
                      </p>
                    </div>
                    <div className="col-md-4 py-2">
                      <p>
                        <strong>Name:</strong> {userData?.name ?? "-"}
                      </p>
                    </div>
                    <div className="col-md-4 py-2">
                      <p>
                        <strong>Email:</strong> {userData?.email ?? "-"}
                      </p>
                    </div>
                    <div className="col-md-4 py-2">
                      <p>
                        <strong>Phone:</strong> {userData?.phone ?? "-"}
                      </p>
                    </div>
                    <div className="col-md-4 py-2">
                      <p>
                        <strong>Address:</strong> {userData?.address ?? "-"}
                      </p>
                    </div>
                    <div className="col-md-4 py-2">
                      <p>
                        <strong>State:</strong> {userData?.state_name ?? "-"}
                      </p>
                    </div>
                    <div className="col-md-4 py-2">
                      <p>
                        <strong>District:</strong>{" "}
                        {userData?.district_name ?? "-"}
                      </p>
                    </div>
                    <div className="col-md-4 py-2">
                      <p>
                        <strong>City:</strong> {userData?.city_name ?? "-"}
                      </p>
                    </div>
                    <div className="col-md-4 py-2">
                      <p>
                        <strong>Role:</strong>{" "}
                        {userData?.role === "0" ? "Admin" : userData?.role_name}
                      </p>
                    </div>
                    <div className="col-md-4 py-2">
                      <p>
                        <strong>Branch Name:</strong>{" "}
                        {userData?.branch_name ?? "-"}
                      </p>
                    </div>
                    <div className="col-md-4 py-2">
                      <p>
                        <strong>Status:</strong>{" "}
                        {userData?.status === 1 ? "Active" : "Inactive"}
                      </p>
                    </div>
                    {/* <div className="col-md-4 py-2">
                      <p>
                        <strong>Is Self:</strong>{" "}
                        {userData?.IsSelf === 1 ? "Yes" : "No"}
                      </p>
                    </div> */}
                    {/* <div className="col-md-4 py-2">
                      <p>
                        <strong>Is User:</strong>{" "}
                        {userData?.IsUser === 1 ? "Yes" : "No"}
                      </p>
                    </div> */}
                    <div className="col-md-4 py-2">
                      <p>
                        <strong>Created By:</strong> {userData?.created_by_name ?? "-"}
                      </p>
                    </div>
                    <div className="col-md-4 py-2">
                      <p>
                        <strong>Created At:</strong>{" "}
                        {userData?.created_at
                          ? new Date(userData.created_at).toLocaleDateString(
                              "en-GB"
                            )
                          : "-"}
                      </p>
                    </div>
                  </div>

                  <div className="mt-3">
                    <strong>Photo:</strong>
                    <div>
                      {userData?.employee_image_url ? (
                        <img
                          src={userData.employee_image_url}
                          alt="User"
                          style={{
                            width: "120px",
                            height: "120px",
                            objectFit: "cover",
                            borderRadius: "8px",
                          }}
                        />
                      ) : (
                        <p>Not Uploaded</p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default UserProfile;
